<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Attendance Holiday</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Table List -->
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-1">
                        <h4 class="mt-2">Country</h4>
                    </div>
                    <div class="col-md-2">
                        <select class="form-control" v-model="countryCode" @change="changeCountry">
                            <option value="MY">Malaysia</option>
                            <option value="SG">Singapore</option>
                        </select>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-1 pr-0">
                        <h4 class="mt-2">Year</h4>
                    </div>
                    <div class="col-md-1 pl-0">
                        <select class="form-control" v-model="year" @change="changeYear">
                            <option value>All</option>
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                </div>

                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
                    <table style="width: auto !important" class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center" style="width: 150px">Date</th>
                                <th class="text-center" style="width: 100px">Day</th>
                                <th class="text-center" style="width: 250px">Name</th>
                                <th class="text-center" style="width: 540px">Work Calendar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ph, i) in publicHolidays" :key="ph.Id">
                                <td v-if="mode == 'view'" class="text-center">{{ ph.DateDisplay }}</td>
                                <td v-if="mode == 'edit'" class="text-center">
                                    <input type="date" v-model="ph.DateInput" @change="getPublicHolidayDay(i)"
                                        class="form-control height26 text-center" 
                                        :min="year ? year + '-01-01' : null"
                                        :max="year ? year + '-12-31' : null"
                                    />
                                </td>

                                <td class="text-center">{{ ph.Day }}</td>

                                <td v-if="mode == 'view'" class="text-center">{{ ph.Name }}</td>
                                <td v-if="mode == 'edit'" class="text-center">
                                    <input type="text" v-model="ph.Name" class="form-control height26 text-center" />
                                </td>

                                <td v-if="mode =='edit'" style="position: relative">
                                    <div class="workcalendar-container">
                                        <template v-for="(item,j) in workCalendars" >
                                            <input :id="'ph' + i + '_' + item.Id + '_' + j" 
                                                type="checkbox" 
                                                v-model="ph.WorkCalendars" 
                                                :key="'phCheckbox' + i + j"
                                                :value="item.Id"/>
                                            <label :for="'ph' + i + '_' + item.Id + '_' + j" :key="'phLabel' + i + j">{{ item.CalendarCode }}</label>
                                        </template>
                                    </div>
                                    <span @click="removePublicHoliday(i)"
                                        style="position: absolute; right: -8px; top: 20px; color: #FF0000; cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>

                            <tr v-for="(newPh, i) in newPublicHolidays" :key="newPh.Id">
                                <td class="text-center">
                                    <input type="date" v-model="newPh.DateInput" @change="getNewPublicHolidayDay(i)"
                                        class="form-control height26 text-center" 
                                        :min="year ? year + '-01-01' : null"
                                        :max="year ? year + '-12-31' : null"
                                    />
                                </td>
                                <td class="text-center">{{ newPh.Day }}</td>
                                <td class="text-center">
                                    <input type="text" v-model="newPh.Name" class="form-control height26 text-center" />
                                </td>
                                <td style="position: relative">
                                    <div class="workcalendar-container">
                                        <template v-for="(item,j) in workCalendars" >
                                            <input :id="'newph' + i + '_' + item.Id + '_' + j" 
                                                type="checkbox" 
                                                v-model="newPh.WorkCalendars" 
                                                :key="'newphCheckbox' + i + j"
                                                :value="item.Id"/>
                                            <label :for="'newph' + i + '_' + item.Id + '_' + j" :key="'newphLabel' + i + j">{{ item.CalendarCode }}</label>
                                        </template>
                                    </div>
                                    <span @click="removeNewPublicHoliday(i)"
                                        style="position: absolute; right: -8px; top: 20px; color: #FF0000; cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>

                            <tr v-if="mode == 'edit'">
                                <td class="text-center" colspan="4">
                                    <button type="button" class="btn btn-primary" @click="addPublicHoliday">
                                        <i class="fa fa-plus"></i> Add Public Holiday
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <button @click="save" type="button" class="btn btn-primary"><i class="fa fa-save"></i>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Table List -->
    </div>
</template>

<script>
import API from "../../http-common.js";

export default {
    data() {
        return {
            countryCode: "SG",
            year: new Date().getFullYear(),
            publicHolidays: [],
            deletedPublicHolidays: [],
            newPublicHolidays: [],
            workCalendars: [],
            mode: "edit"
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        days() {
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            return days;
        },
        years() {
            let currentYear = new Date().getFullYear();
            let years = [];
            for (let i = currentYear + 1; i >= currentYear - 5; i--) {
                years.push(i);
            }
            return years;
        }
    },

    methods: {
        getPublicHolidayDay(index) {
            let ph = this.publicHolidays[index];
            let phDate = new Date(ph.DateInput);
            let day = this.days[phDate.getDay()];
            Vue.set(this.publicHolidays, index, { Id: ph.Id, DateInput: ph.DateInput, Day: day, Name: ph.Name, WorkCalendars: ph.WorkCalendars });
        },
        getNewPublicHolidayDay(index) {
            let phDate = new Date(this.newPublicHolidays[index].DateInput);
            this.newPublicHolidays[index].Day = this.days[phDate.getDay()];
        },
        dateFormatted(val) {
            let dateArr = val.split("-");
            return `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;
        },
        addPublicHoliday() {
            this.newPublicHolidays.push({ DateInput: '', Day: '', Name: '' , WorkCalendars: []});
        },
        removeNewPublicHoliday(index) {
            this.newPublicHolidays.splice(index, 1);
        },
        removePublicHoliday(index) {
            this.deletedPublicHolidays.push(this.publicHolidays[index]);
            this.publicHolidays.splice(index, 1);  
        },
        changeCountry() {
            this.newPublicHolidays = [];
            this.deletedPublicHolidays = [];
            this.getPublicHolidays();
        },
        changeYear(){
            this.newPublicHolidays = [];
            this.deletedPublicHolidays = [];
            this.getPublicHolidays();
        },
        getPublicHolidays() {
            let param = {
                Token: this.token,
                CountryCode: this.countryCode,
                YearFilter: this.year
            };
            this.$store.state.isLoading = true;
            API.getPublicHolidays(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        if (response.data.record) this.publicHolidays = response.data.record;

                        //populate day
                        for (let item of this.publicHolidays) {
                            let phDate = new Date(item.DateCalendar);
                            item.Day = this.days[phDate.getDay()];
                            item.DateInput = item.DateCalendar;
                        }
                        //populate work calendars
                        this.workCalendars = response.data.workCalendars;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            //check duplicate date
            let messages = [];
            let allPublicHolidays = this.publicHolidays.concat(this.newPublicHolidays);
            for (let item of allPublicHolidays) {
                if (item.DateInput) {
                    let records = allPublicHolidays.filter(c => c.DateInput == item.DateInput);
                    if (records && records.length > 1) {
                        messages.push("Public Holiday on date: '" + this.dateFormatted(item.DateInput) + "' is duplicated.");
                    }
                }
            }
            //check empty date           
            for (let item of allPublicHolidays) {
                if (item.Name && !item.DateInput) {
                    messages.push("Public Holiday: '" + item.Name + "' cannot have empty date.");
                }
                if (!item.Name && item.DateInput) {
                    messages.push("Public Holiday on date: '" + this.dateFormatted(item.DateInput) + "' cannot have empty name.");
                }
            }
            if (messages.length > 0) {
                messages = [...new Set(messages)];
                this.$swal(messages.join("\n"), { icon: "error" });
                return;
            }

            let param = {
                Token: this.token,
                CountryCode: this.countryCode,
                PublicHolidays: this.publicHolidays,
                NewPublicHolidays: this.newPublicHolidays,
                DeletedPublicHolidays: this.deletedPublicHolidays
            }
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the public holiday?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.savePublicHoliday(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            this.publicHolidays = [];
                            this.newPublicHolidays = [];
                            this.getPublicHolidays();
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        if (this.role != "admin") this.$router.replace({ name: "home" });
        this.getPublicHolidays();
    }
}
</script>

<style scoped>
.workcalendar-container{
    display: flex;
    flex-wrap: wrap;
}
.workcalendar-container label{
    margin-bottom: -0.2rem;
    width: 150px;
}

.workcalendar-container label{
    margin-bottom: -0.2rem;
    width: 150px;
    cursor: pointer;
}

.workcalendar-container input[type='checkbox']{
    margin-right: 3px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/System/PublicHoliday.vue